export type ImgPreset = Readonly<{
  w?: number; // width
  h?: number; // height
  q: number; // quality
}>;

function clampQuality(q?: number | string, fallback = 75) {
  const n = Number(q);
  const val = Number.isFinite(n) ? n : fallback;
  return Math.min(100, Math.max(1, Math.round(val)));
}

const PROXY_KEY = "t";

enum ImgProxyOptions {
  resize = "resize",
  format = "format",
  quality = "quality",
  scale = "scale",
}

enum ImgProxyFormat {
  webp = "webp",
}

enum ImgProxyResize {
  fit = "fit",
}

export function checkUrl(input: string) {
  try {
    const url = new URL(input);
    const params = url.searchParams;
    return params.has(PROXY_KEY);
  } catch (error) {
    console.error("IMGPROXY ERROR", error);
    return false;
  }
}

export function getProxyParams(imgPreset: ImgPreset): string {
  try {
    const w = imgPreset.w ?? undefined;
    const h = imgPreset.h ?? undefined;
    const q = clampQuality(imgPreset.q);

    let query = `&${PROXY_KEY}=`;

    if (w && h) {
      query += `
        ${ImgProxyOptions.resize}
        :${w}x${h}
        ,${ImgProxyResize.fit}|
      `.replace(/\s+/g, "");
    }

    query += `${ImgProxyOptions.format}:${ImgProxyFormat.webp},${q}`;
    return query;
  } catch (error) {
    logError(error, { context: { feature: "imgproxy", step: "exportImg" } });
    console.error("IMGPROXY ERROR", error);
    return "";
  }
}
